import getAppName from './getAppName';
export function isGlobalNavAcademyMode() {
  return getAppName() === 'LearningCenterUI';
}